export default __webpack_public_path__ + "static/media/user.965eb262.svg";